<template>
  <div class="card my-3">
    <div class="card-header">
      <span>{{ title }}</span>
    </div>
    <div class="card-body">
      <canvas :id="chartid"></canvas>
    </div>
    <!-- <div class="card-footer">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">名称</th>
            <th scope="col">パーセンタイル</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="p in datasets" v-bind:key="p.trait_id">
            <td>{{ p.name }}</td>
            <td>{{ p.percentile }}</td>
          </tr>
        </tbody>
      </table>
    </div> -->
  </div>
</template>

<style scoped>
canvas {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
</style>

<script>
import Chart from 'chart.js'
import _ from 'lodash'

export default {
  name: 'ResultCard',
  myChart: null,
  props: [ 'datasets', 'title' ],
  computed: {
    chartid () {
      return 'chart-' + this.title
    }
  },
  watch: {
    datasets () {
      if (!this.datasets[0].length) {
        return
      }

      this.myChart.data.labels = _.map(this.datasets[0], (d) => d.name)
      this.myChart.data.datasets = [
        {
          label: 'あなた',
          data: _.map(this.datasets[0], (d) => d.percentile),
          backgroundColor: [ 'rgba(54, 162, 235, 0.2)' ],
          borderColor: [ 'rgba(54, 162, 235, 1)' ],
          borderWidth: 2
        },
        {
          label: '業界平均',
          data: _.map(this.datasets[1], (d) => d.percentile),
          backgroundColor: [ 'rgba(255, 206, 86, 0.2)' ],
          borderColor: [ 'rgba(255, 206, 86, 1)' ],
          borderWidth: 2
        }
      ]

      this.myChart.update(0)
    }
  },
  mounted () {
    var ctx = document.getElementById('chart-' + this.title)
    this.myChart = new Chart(ctx, {
      type: 'radar',
      options: {
        legend: {
          display: true
        },
        scale: {
          ticks: {
            min: 0,
            max: 1
          },
          pointLabels: {
            fontSize: 15
          }
        }
      }
    })
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ResultCard.vue